// Feelgood Webshop-Restyle: Markiert Webshop-Seiten mit body.fg-shop.
//
// shop_style.scss scope't alle Webshop-Anpassungen auf body.fg-shop, damit
// ausschliesslich der Shop (Listing, Produktdetailseite, Warenkorb, Orders)
// im Portal-Stil gerendert wird - andere Portal-Seiten bleiben unangetastet.
// Kennung servergerenderter Webshop-Container:
//   - Listing/Produktuebersicht: #product-listing (item-card-group-section)
//   - Produktdetailseite:       .product-page-content
//   - Warenkorb:                #page-cart
//   - Bestellungen:             Route /orders... (ERPNext-Portal, gehoert zum
//                               Shop-Durchlauf: Payment-Button/Steuerzeile)
(function () {
	var MARKERS = "#product-listing, .product-page-content, #page-cart";
	var ROUTE_RE = /^\/(orders(\/|$)|all-products(\/|$)|cart(\/|$))/;

	function apply() {
		var isShop = !!document.querySelector(MARKERS) || ROUTE_RE.test(window.location.pathname);
		if (isShop) {
			document.body.classList.add("fg-shop");
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", apply);
	} else {
		apply();
	}
})();
